/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Twda_Failed_Fork_SyncInputs */



/**
* | output |
* | --- |
* | "our archive fork could not be synchronised" |
*
* @param {Twda_Failed_Fork_SyncInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const twda_failed_fork_sync = /** @type {((inputs?: Twda_Failed_Fork_SyncInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Twda_Failed_Fork_SyncInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("notre fork de l'archive n'a pas pu être synchronisé")
	if (locale === "es") return /** @type {LocalizedString} */ ("nuestro fork del archivo no se pudo sincronizar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("nosso fork do arquivo não pôde ser sincronizado")
	if (locale === "it") return /** @type {LocalizedString} */ ("il nostro fork dell'archivio non è stato sincronizzato")
	return /** @type {LocalizedString} */ ("our archive fork could not be synchronised")
});